import { useEffect } from "react";
import { applyStoredConsentOnLoad } from "@/lib/consent";

/**
 * Re-applies a previously stored Consent Mode choice on every page load.
 */
export function ConsentBootstrap(): null {
  useEffect(() => {
    applyStoredConsentOnLoad();
  }, []);

  return null;
}
